import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

export class Loader extends Component {

  static propTypes = {
    size: PropTypes.number,
    color: PropTypes.string
  }

  static defaultProps = {
    size: 200,
    color: '#5c9693'
  }

  loaderStyle = () => {
    return {
      width: this.props.size,
      height: this.props.size,
      borderTopColor: this.props.color,
      borderBottomColor: this.props.color,
      borderRightColor: this.props.color,
    }
  }

  render = () =>
    <div className={styles.loader} style={this.loaderStyle()}/>
}

const styles = StyleSheet({
  loader: {
    margin:"20px auto",
    fontSize:"10px",
    position:"relative",
    textIndent:"-9999em",
    borderTop:"1.1em solid rgba(255, 255, 255, 0.2)",
    borderRight:"1.1em solid rgba(255, 255, 255, 0.2)",
    borderBottom:"1.1em solid rgba(255, 255, 255, 0.2)",
    borderLeft:"1.1em solid transparent",
    transform:"translateZ(0)",
    animation:"load8 1.1s infinite linear",
    borderRadius:"50%",
    width:"10em",
    height:"10em",
    '& :after': {
      borderRadius:"50%",
      width:"10em",
      height:"10em"
    }
  },
  '@keyframes load8':{
    '0%': {
      transform:"rotate(0deg)"
    },
    '100%': {
      transform:"rotate(360deg)"
    }
  }

}, {index: 1000, meta: 'TokenPortal sheet', classNamePrefix: 'TPLoader'})
export default Loader
